import * as React from 'react'

const AddedPasskeyIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="96"
    height="96"
    fill="none"
    viewBox="0 0 96 96"
  >
    <path
      stroke="#004B4E"
      strokeLinecap="round"
      strokeWidth="3"
      d="M58.052 90.43a45 45 0 0 1-11.14 1.392C22.106 91.822 2 71.715 2 46.912 2 22.106 22.107 2 46.911 2s44.911 20.107 44.911 44.911c0 3.846-.483 7.578-1.392 11.14"
    ></path>
    <path
      fill="url(#paint0_linear_2903_97)"
      d="M77.2 58.4a18.8 18.8 0 1 0 0 37.6 18.8 18.8 0 0 0 0-37.6"
    ></path>
    <path
      fill="#004B4E"
      fillRule="evenodd"
      d="M87.494 68.368c.363.268.44.78.173 1.143l-11.444 15.53a.817.817 0 0 1-1.168.154l-8.174-6.54a.817.817 0 0 1 1.021-1.276l7.51 6.008L86.35 68.541a.817.817 0 0 1 1.143-.173"
      clipRule="evenodd"
    ></path>
    <path
      fill="#004B4E"
      d="M44.461 47.26a7.078 7.078 0 1 0 0-14.157 7.078 7.078 0 0 0 0 14.157M63.337 47.26a5.506 5.506 0 1 0-7.865 4.954v8.416l2.36 2.36 3.932-3.933-2.36-2.36 2.36-2.36-1.95-1.95a5.51 5.51 0 0 0 3.523-5.127m-5.506 0a1.573 1.573 0 1 1 0-3.147 1.573 1.573 0 0 1 0 3.147M50.659 50.437a9.4 9.4 0 0 0-3.838-.818H42.1a9.44 9.44 0 0 0-9.437 9.438v3.146h20.448v-8.667a8.1 8.1 0 0 1-2.453-3.099"
    ></path>
    <defs>
      <linearGradient
        id="paint0_linear_2903_97"
        x1="58.4"
        x2="96"
        y1="77.2"
        y2="77.2"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BCEDFA"></stop>
        <stop offset="1" stopColor="#BFEFF2"></stop>
      </linearGradient>
    </defs>
  </svg>
)

export default AddedPasskeyIcon
